import request from '@/utils/request';

export const ADMIN_WALLET_INVOICES = 'ADMIN_WALLET_INVOICES';
export const ADMIN_MAX_PLUS_SUBSCRIPTIONS = 'ADMIN_MAX_PLUS_SUBSCRIPTIONS';

export const fetchInvoices =
  (query = {}) =>
  async dispatch => {
    const response = await request({
      path: `/v1/admin/wallets/invoices`,
      query
    });
    dispatch({
      payload: response,
      type: ADMIN_WALLET_INVOICES
    });
  };

export const fetchMaxPlusSubscriptions =
  (query = {}) =>
  async dispatch => {
    const response = await request({
      path: `/v1/admin/wallets/max_plus_subscriptions`,
      query
    });
    dispatch({
      payload: response,
      type: ADMIN_MAX_PLUS_SUBSCRIPTIONS
    });
  };

export const createMaxPlusSubscription =
  (body = {}) =>
  async () =>
    await request({
      path: `/v1/admin/wallets/max_plus_subscriptions`,
      method: 'POST',
      body
    });

export const updateMaxPlusSubscriptionById =
  (id, body = {}) =>
  async () =>
    await request({
      path: `/v1/admin/wallets/max_plus_subscriptions/${id}`,
      method: 'PATCH',
      body
    });

export const addFundsToWallet =
  (body = {}) =>
  async () =>
    await request({
      path: `/v1/admin/wallets/max_plus_subscriptions/${body.subscription_id}/add_funds`,
      method: 'POST',
      body
    });
